export default "__VITE_ASSET__CqMhOnGU__";